<template lang="html">
  <section class="slider-suministros">
    <div class="container fixed-head">
      <h2 class="title-type -white">
        {{ $t('home.suministros.title') }}
      </h2>
    </div>
    <slick ref="slick" :options="slickOptions">
      <article class="slide" data="luz">
        <div class="slide-container row-between">
          <div class="contenedor-textos">
            <h2>
              <span class="-white">
                {{ $t('home.suministros.finds') }}
              </span>
              <span class="-white">
                {{ $t('home.suministros.fee') }}
                {{ $t('home.suministros.light') }}
              </span>
            </h2>
          </div>
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-white">
                {{ $t('home.suministros.finds') }}
              </span>
              <span class="-white">
                {{ $t('home.suministros.fee') }}
                {{ $t('home.suministros.light') }}
              </span>
            </h2>
            <div class="contenedor-titulo row-end">
              <div class="info-principal">
                <h3 class="tipo-tarifa row-start">
                  <span class="-white">
                    {{ $t('home.suministros.yourFee') }}
                    <strong>{{ $t('home.suministros.light') }}</strong>
                  </span>
                </h3>
                <h3 class="precio-coste">TRANQUILIDAD</h3>
                <h4 class="precio" style="color: #1E2E37;" v-if="!!precios">
                  <strong>{{ precios.tarifas_luz.tranquilidad.fixed.p1 | comma }}</strong>
                  <span>€/kWh</span>
                </h4>
              </div>

              <div class="contenedor-botones row-center">
                <router-link :to="$t('enlaces.inergizate') + '?suministro=luz'" title="Contrata" class="btn -degree">
                  {{ $t('home.suministros.btnEnergize') }}
                </router-link>
                <router-link :to="$t('enlaces.tarifas_luz')" class="btn -skull-orange -gray-c">
                  {{ $t('home.suministros.btnShowRates') }}
                  {{ $t('home.suministros.light') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="slide" data="gas">
        <div class="slide-container row-between">
          <div class="contenedor-textos">
            <h2>
              <span class="-white">
                {{ $t('home.suministros.finds') }}
              </span>
              <span class="-white">
                {{ $t('home.suministros.fee') }}
                {{ $t('home.suministros.gas') }}
              </span>
            </h2>
          </div>
          <div class="contenedor-imagen ">
            <h2 class="titulo-mvl">
              <span class="-white">
                {{ $t('home.suministros.finds') }}
              </span>
              <span class="-white">
                {{ $t('home.suministros.fee') }}
                {{ $t('home.suministros.gas') }}
              </span>
            </h2>
            <div class="contenedor-titulo row-end">
              <div class="info-principal-container">
                <div class="info-principal">
                  <h3 class="tipo-tarifa -white row-start">
                    <span class="-white">
                      {{ $t('home.suministros.offer') }}<br>
                    </span>
                  </h3>
                  <h3 class="precio-coste -orange" v-html="$t('home.suministros.offerDescription')"> </h3>
                </div>
                <div class="contenedor-botones row-start">
                  <router-link :to="$t('enlaces.tarifas_gas')" class="btn -skull-orange -gray-c">
                    {{ $t('home.suministros.btnShowRates') }}
                    {{ $t('home.suministros.gas') }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </slick>
  </section>
</template>

<script lang="js">
import Slick from 'vue-slick';
import { mapGetters } from 'vuex';

export default {
  name: 'slider-suministros',
  components: { Slick },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        initialSlide: 0,
        autoplay: false,
        speed: 2000,
        autoplaySpeed: 5000,
      },
    }
  },
  computed: {
    ...mapGetters({
      precios: 'getPrecios'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/parts/slider-suministros.vue